export const PRICE = {
    // 상품 가격 정책
    IS_MEMBER_PRICE: (isSubscribed: boolean, isNewProduct: boolean) => 
      isSubscribed && isNewProduct,  // true면 회원가, false면 비회원가
  
    // 배송비 정책
    IS_MEMBER_SHIPPING: (isSubscribed: boolean) => isSubscribed  // true면 기본배송비, false면 2배
  }
  
  
  export const calculateProductPrice = (price: number, isSubscribed: boolean, isNewProduct: boolean) => {
    return PRICE.IS_MEMBER_PRICE(isSubscribed, isNewProduct) ? price : price * 2;
  }

  
  // 한국이고 구독자면 기존 shipping_fee, 한국이고 비구독자면 2배 shipping_fee, 한국이 아니면 shipping_fee는 무조건 0원
  export const calculateShippingThreshold = (threshold: number, isSubscribed: boolean, isKorea?: boolean) => {
    if (!isKorea) return 0;
    return PRICE.IS_MEMBER_SHIPPING(isSubscribed) ? threshold : threshold * 2;
  }
